export const VERTICAL_B2B = 'B2B';
export const VERTICAL_CONSUMER = 'CONSUMER';

export type Vertical = typeof VERTICAL_B2B | typeof VERTICAL_CONSUMER;
